import React from "react";
// Importa tu archivo CSS aquí si lo tienes separado
import "./GroupCard.css";

// =================================================================
// Componente Badge para los Tags (Reutilizado de Eventos)
// =================================================================
function GroupTagsBadge({ tags }) {
  // Colores para los tags circulares
  const coloresCirculos = ["#00C2FF", "#97C100", "#FF2D52"]; // Asegurarse de que 'tags' es un array antes de mapear

  const validTags = Array.isArray(tags) ? tags : [];

  return (
    <span className="group-tags-badge-group">
      {validTags.map((letra, idx) => (
        <span
          key={idx}
          className="badge-circulo"
          style={{
            backgroundColor: coloresCirculos[idx % coloresCirculos.length], // Margen negativo para el efecto de superposición
            marginRight: idx < validTags.length - 1 ? "-8px" : "10px",
            zIndex: 10 - idx, // Orden de apilamiento
            border: "2px solid #fff",
          }}
        >
          {letra}
        </span>
      ))}
    </span>
  );
}

// =================================================================
// Componente Principal GroupCard (50/50 Responsivo)
// =================================================================
const GroupCard = ({
  sharedGroupId, // <--- NUEVA PROP: ID hasheado provisto por el backend
  groupId, // Nuevo: ID para acciones específicas
  title,
  description,
  tagsMembers,
  members,
  tipoGrupo,
  imageUrl,
  isMember = false, // Nuevo: Indica si el usuario es miembro
  isOwner = false, // Nuevo: Indica si el usuario es el dueño
  onViewGroupDetail,
  onJoinLeaveGroup, // Nueva función para unirse/salir
  onAdminGroup, // Nueva función para administrar
}) => {
  // Manejar el clic al botón "Ver más"
  const handleViewDetail = () => {
    if (onViewGroupDetail) {
      onViewGroupDetail(sharedGroupId);
    } else {
      console.log(
        `Ver detalles del grupo: ${title} (ID: ${groupId}) Hasheado id es: ${sharedGroupId}`
      ); // Aquí se podría implementar la navegación real si fuera necesario
    }
  }; // ----------------------------------------------------- // Lógica para Botones de Acción // -----------------------------------------------------

  let actionButton = null;
  let actionLabel = "";
  let actionClass = "btn-secondary";
  let actionFunction = null;
  let actionIcon = "bi-person-plus-fill";

  if (isOwner) {
    // 1. Botón de Administración (si es el dueño)
    actionLabel = "Administrar";
    actionClass = "btn btn-warning btn-sm fw-bold";
    actionIcon = "bi-gear-fill";
    actionFunction = () => onAdminGroup && onAdminGroup(sharedGroupId);
  } else if (isMember) {
    // 2. Botón de Salir del Grupo (si es miembro)
    actionLabel = "Salir del Grupo";
    actionClass = "btn btn-outline-danger btn-sm fw-bold";
    actionIcon = "bi-box-arrow-right";
    actionFunction = () =>
      onJoinLeaveGroup && onJoinLeaveGroup(sharedGroupId, "leave");
  } else {
    // 3. Botón de Unirse (si no es miembro)
    actionLabel = "Unirse al Grupo";
    actionClass = "btn btn-success btn-sm fw-bold";
    actionIcon = "bi-person-plus-fill";
    actionFunction = () =>
      onJoinLeaveGroup && onJoinLeaveGroup(sharedGroupId, "join");
  }

  actionButton = (
    <button
      className={actionClass}
      onClick={actionFunction}
      aria-label={actionLabel}
    >
      <i className={`bi ${actionIcon} me-1`}></i> {actionLabel}
    </button>
  );

  return (
    // d-flex flex-column (Móvil: vertical)
    // flex-md-row-reverse (Escritorio: horizontal e invertido -> Imagen derecha)
    <div className="group-card d-flex flex-column flex-md-row shadow-sm">
      <div className="group-card-image-wrapper w-md-50">
        <img src={imageUrl} alt={title} className="group-card-img" />
      </div>
      <div className="group-card-content w-100 w-md-50 p-3 d-flex flex-column justify-content-between">
        <div>
          <div className="group-card-title fw-bold mb-1">{title}</div>
          <hr></hr>
          <div className="group-card-description text-muted mb-3">
            {description}
          </div>

          {/* Nuevo: Tipo de Grupo movido debajo del título/descripción */}

          <span className="group-type-badge mb-2 d-inline-block">
            {tipoGrupo}
          </span>
          {/* Tags e Info de Miembros */}
          <div className="d-flex align-items-center mb-3">
            <GroupTagsBadge tags={tagsMembers} />
            <span className="group-members-text small text-muted ms-1 fw-bold">
              {members} usuario(s)
            </span>
          </div>
        </div>
        {/* Meta: Botones de Acción */}
        <div className="d-flex align-items-center justify-content-between pt-2 border-top-line">
          <button
            className="btn-ver-mas"
            onClick={handleViewDetail}
            aria-label={`Ver más detalles de ${title}`}
          >
            <i className="bi bi-eye-fill me-1"></i> Ver más
          </button>
          {actionButton}
        </div>
      </div>
    </div>
  );
};

export default GroupCard;
